import type { MediaPlan } from '@mint-sdk/api-media-plan';

import { MP_LEVELS } from '../consts/index.js';

export const findActivityIdForActivity = (
  activityMediaDataId: string,
  sidebarTree: MediaPlan.SidebarItem,
): string =>
  sidebarTree.subItems.find(
    (activity) => activity.mediaDataId === activityMediaDataId,
  )?.activityId ?? '';

export const findActivityIdForFlight = (
  flightMediaDataId: string,
  sidebarTree: MediaPlan.SidebarItem,
): string =>
  sidebarTree.subItems.find((activity) =>
    activity.subItems.some(
      (flight) => flight.mediaDataId === flightMediaDataId,
    ),
  )?.activityId ?? '';

export const getActivityIdForLevel = (
  level: string,
  mediaDataId: string | undefined,
  sidebarTree: MediaPlan.SidebarItem | undefined,
): string => {
  if (!mediaDataId || !sidebarTree) {
    return '';
  }

  if (level === MP_LEVELS.FLIGHT) {
    return findActivityIdForFlight(mediaDataId, sidebarTree);
  }

  if (level === MP_LEVELS.ACTIVITY) {
    return findActivityIdForActivity(mediaDataId, sidebarTree);
  }

  return '';
};
